import React, { useState, Fragment, useEffect } from 'react'
import { ReportLayout } from "./../../components"
import {
  Tabs,
  Tab,
  makeStyles,
  TableCell
} from "@material-ui/core"
import { TablePanel, ReportCards } from "./../../components"
import { GraphicPanel, PieChartImagine } from "./../../components"
import { useSelector, useDispatch } from "react-redux";
import { useWindowSize } from '../../hooks';
import config from '../../config';
import moment from 'moment';
import { tableCss } from './../../components/Tables/TableCss';
import { useTranslation } from 'react-i18next';
import { reportActions } from "./../../actions"

const useStyles = makeStyles((theme) => ({
  tab: {
    width: "50%",
    maxWidth: "unset",
    backgroundColor: theme.palette.neutrals.high.main,
    border: "1px solid theme.palette.neutrals.high.medium",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  }
}))

export const ReportAccessColaborator = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const tableClasses = tableCss();
  const [tabIndex, setTabIndex] = useState(0);
  const [arrItensCard, setArrItensCArd] = useState({
    cardContent: [],
    dialogContent: []
  })
  const [width] = useWindowSize();
  const { report, chart, tab } = useSelector(state => state.report);
  const { t } = useTranslation();

  const tableInfo = {
    columns: [
      { id: 'colaborador', label: t('colaborador') },
      { id: 'status', label: t('matrícula') },
      { id: 'local', label: t('local') },
      { id: 'area', label: t('area') },
      { id: 'date', label: t('data') },
      { id: 'perfil', label: t('perfil') },
    ],
    data: report.map(item => (
      <Fragment>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.name}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.enrolment}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.bul?.local.name}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.bul?.occupationArea.name}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{`${moment(item.registerDate).format('DD/MM/YYYY')}`}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.typeProfile}</TableCell>
      </Fragment>
    )),
  }

  useEffect(() => {
    setArrItensCArd({
      cardContent: report.map(item => (
        [
          {
            name: "colaborador",
            value: item.name,
          },
          {
            name: "matrícula",
            value: item.enrolment
          },
          {
            name: "local",
            value: item.bul?.local.name
          }
        ]
      )),
      dialogContent: report.map(item => (
        [
          {
            name: "colaborador",
            value: item.name,
          },
          {
            name: "matrícula",
            value: item.enrolment
          },
          {
            name: "local",
            value: item.bul?.local.name
          },
          {
            name: "area",
            value: item.bul?.occupationArea.name
          },
          {
            name: "data",
            value:  moment(item.registerDate).format('DD/MM/YYYY')
          },
          {
            name: "perfil",
            value: item.typeProfile
          }
        ]
      ))
    })
  }, [report])

  useEffect(() => {
    return () => {
      dispatch(reportActions.clearAll())
    }
  }, [dispatch])

  function handleChangeTab(index) {
    dispatch(reportActions.changeTab(index === 0 ? "table" : "graph"));
    setTabIndex(index)
  }
  
  return (
    <ReportLayout title={t('acessos_de_colaboradores')}>
      <Tabs value={tabIndex} onChange={(e, value) => handleChangeTab(value)} aria-label="Tabs de grafico e tabela" indicatorColor="primary">
        <Tab className={classes.tab} label={t('tabela')} aria-controls="Panel tabela" />
        <Tab className={classes.tab} label={t('grafico')} aria-controls="Panel grafico" />
      </Tabs>

      { tab === "table" && (
        <Fragment>
          { width > config.RESPONSIVE_MOBILE ?  
            <TablePanel tableInfo={tableInfo} /> : 
            <ReportCards arrItems={arrItensCard} /> 
          }
        </Fragment>
      )}

      { tab === "graph" && (
        <GraphicPanel>
          <PieChartImagine data={chart} />
        </GraphicPanel>
      )}
    </ReportLayout>
  )
}
